define("knockout", [], function (
) {
    return ko;
});